// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XA6E","right":"styles_right__1XIFF"};